var e = /* @__PURE__ */ ((i) => (i.MeetingMemory = "meeting-memory", i.MeetingMemorySpeech = "meeting-memory-speech", i.CrmIntegrations = "crm-integrations", i.AiFeedVisibility = "ai-feed-visibility", i.RecallCalendarIntegration = "recall-calendar-integration", i.Lobby = "lobby", i.Dev = "dev", i.Internal = "internal", i))(e || {});
export {
  e as PostHogFeatureFlag
};
